import { render, staticRenderFns } from "./MainProjectOffer.vue?vue&type=template&id=695e6b6c&scoped=true&"
import script from "./MainProjectOffer.vue?vue&type=script&lang=js&"
export * from "./MainProjectOffer.vue?vue&type=script&lang=js&"
import style0 from "./MainProjectOffer.vue?vue&type=style&index=0&id=695e6b6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695e6b6c",
  null
  
)

export default component.exports